import React from 'react';
import { IIconProps } from './utils';

export const Timeline = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M5 21C6.38071 21 7.5 22.1193 7.5 23.5C7.5 24.8807 6.38071 26 5 26C3.61929 26 2.5 24.8807 2.5 23.5C2.5 22.1193 3.61929 21 5 21Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M25 21C26.3807 21 27.5 22.1193 27.5 23.5C27.5 24.8807 26.3807 26 25 26C23.6193 26 22.5 24.8807 22.5 23.5C22.5 22.1193 23.6193 21 25 21Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M3 15L27 15"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
    <path
      d="M5 15L5 21"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
    <path
      d="M9.5 9C8.11929 9 7 7.88071 7 6.5C7 5.11929 8.11929 4 9.5 4C10.8807 4 12 5.11929 12 6.5C12 7.88071 10.8807 9 9.5 9Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M9.5 15L9.5 9"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
    <path
      d="M20.5 9C19.1193 9 18 7.88071 18 6.5C18 5.11929 19.1193 4 20.5 4C21.8807 4 23 5.11929 23 6.5C23 7.88071 21.8807 9 20.5 9Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M20.5 15L20.5 9"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
    <path
      d="M15 15L15 21"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
    <path
      d="M25 15L25 21"
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
    <path
      d="M15 21C16.3807 21 17.5 22.1193 17.5 23.5C17.5 24.8807 16.3807 26 15 26C13.6193 26 12.5 24.8807 12.5 23.5C12.5 22.1193 13.6193 21 15 21Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
